export enum DialogFace {
  DEFAULT = 'default',
  PRIMARY = 'primary'
}
